import { defineComponent as E, computed as U, createElementBlock as f, createBlock as u, unref as e, openBlock as s, normalizeClass as k, createElementVNode as P, createVNode as c, isRef as W, withCtx as y, createCommentVNode as H } from "vue";
import S from "../../components/EmptyState.vue.js";
import N from "../../components/ViewLayout/ViewLayout.vue.js";
import g from "../../components/ViewLayout/ViewLayoutContent.vue.js";
import { useSidebar as B } from "../../hooks/useSidebar.js";
import { importCurlCommand as I } from "../../libs/importers/curl.js";
import { useActiveEntities as L } from "../../store/active-entities.js";
import z from "./RequestSection/RequestSection.vue.js";
import A from "./RequestSubpageHeader.vue.js";
import D from "./ResponseSection/ResponseSection.vue.js";
import { useWorkspace as b } from "../../store/store.js";
import { useLayout as M } from "../../hooks/useLayout.js";
const O = { class: "flex h-full" }, T = {
  key: 0,
  class: "flex h-full flex-1 flex-col"
}, re = /* @__PURE__ */ E({
  __name: "Request",
  props: {
    invalidParams: {},
    selectedSecuritySchemeUids: {},
    requestResult: {}
  },
  emits: ["newTab"],
  setup($) {
    const { events: R } = b(), { isSidebarOpen: a } = B(), q = b(), { layout: h } = M(), {
      activeCollection: r,
      activeExample: m,
      activeRequest: l,
      activeWorkspace: i,
      activeServer: p,
      activeEnvVariables: d,
      activeEnvironment: v,
      activeWorkspaceRequests: x
    } = L(), { modalState: C, requestHistory: V } = q, w = U(
      () => [...V].reverse().find((t) => {
        var o;
        return t.request.uid === ((o = m.value) == null ? void 0 : o.uid);
      })
    );
    function _(t) {
      var o;
      R.commandPalette.emit({
        commandName: "Import from cURL",
        metaData: {
          parsedCurl: I(t),
          collectionUid: (o = r.value) == null ? void 0 : o.uid
        }
      });
    }
    return (t, o) => e(r) && e(i) ? (s(), f("div", {
      key: 0,
      class: k(["bg-b-1 relative z-0 flex h-full flex-1 flex-col overflow-hidden pt-0", {
        "!mr-0 !mb-0 !border-0": e(h) === "modal"
      }])
    }, [
      P("div", O, [
        e(l) ? (s(), f("div", T, [
          c(A, {
            modelValue: e(a),
            "onUpdate:modelValue": o[0] || (o[0] = (n) => W(a) ? a.value = n : null),
            collection: e(r),
            envVariables: e(d),
            environment: e(v),
            operation: e(l),
            server: e(p),
            workspace: e(i),
            onHideModal: o[1] || (o[1] = () => e(C).hide()),
            onImportCurl: _
          }, null, 8, ["modelValue", "collection", "envVariables", "environment", "operation", "server", "workspace"]),
          c(N, null, {
            default: y(() => [
              e(m) ? (s(), u(g, {
                key: 0,
                class: k(["flex-1", [e(a) ? "sidebar-active-hide-layout" : ""]])
              }, {
                default: y(() => {
                  var n;
                  return [
                    c(z, {
                      collection: e(r),
                      envVariables: e(d),
                      environment: e(v),
                      example: e(m),
                      invalidParams: t.invalidParams,
                      operation: e(l),
                      selectedSecuritySchemeUids: t.selectedSecuritySchemeUids,
                      server: e(p),
                      workspace: e(i)
                    }, null, 8, ["collection", "envVariables", "environment", "example", "invalidParams", "operation", "selectedSecuritySchemeUids", "server", "workspace"]),
                    c(D, {
                      collection: e(r),
                      operation: e(l),
                      workspace: e(i),
                      requestResult: t.requestResult,
                      numWorkspaceRequests: e(x).length,
                      response: (n = w.value) == null ? void 0 : n.response
                    }, null, 8, ["collection", "operation", "workspace", "requestResult", "numWorkspaceRequests", "response"])
                  ];
                }),
                _: 1
              }, 8, ["class"])) : H("", !0)
            ]),
            _: 1
          })
        ])) : (s(), u(S, { key: 1 }))
      ])
    ], 2)) : (s(), u(S, { key: 1 }));
  }
});
export {
  re as default
};
